// extracted by mini-css-extract-plugin
export default {"svgMapContainer":"SvgMap_svgMapContainer__wYs9O","svgMap":"SvgMap_svgMap__-VJp-","svgMapWithPanZoom":"SvgMap_svgMapWithPanZoom__RDq0z"};